import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { CHAIN_ID } from '@/constants/chain';
import { IInstrumentRecord, IMetaInstrument } from '@/types/pair';

import { bigNumberObjectCheck } from '@/utils';
import { reduceFutures } from '@/utils/pair';

import { Context } from '@derivation-tech/context';
import { Instrument } from '@synfutures/sdks-perp';
import { syn_getAllFutures } from '../syn/action';

export const setFuturesCore = createAction<{
  chainId: CHAIN_ID;
  underlyingId: string;
  underlying: Partial<IMetaInstrument>;
}>('futures/setFuturesCore');

export const getAllFuturesFromChain = createAsyncThunk(
  'futures/getAllFuturesFromChain',
  async (
    {
      chainId,
      sdkContext,
    }: // marginType,
    {
      chainId: CHAIN_ID;
      userAddr: string;
      // marginType: MARGIN_TYPE;
      sdkContext: Context;
    },
    { dispatch },
  ): Promise<Instrument[] | undefined> => {
    try {
      const instrumentList = await dispatch(syn_getAllFutures({ chainId, sdkContext })).unwrap();
      instrumentList && dispatch(parseInstrumentToMeta({ chainId, instrumentList }));
      return instrumentList;
    } catch (error) {
      console.error('🚀 ~ error:', error);
    }
  },
);

export const parseInstrumentToMeta = createAsyncThunk(
  'futures/parseInstrumentToMeta',
  async ({
    chainId,
    instrumentList,
  }: {
    chainId: CHAIN_ID;
    instrumentList: Instrument[];
  }): Promise<IInstrumentRecord | undefined> => {
    if (instrumentList) {
      try {
        const instrumentMap = instrumentList
          .filter((futures) => !!futures.quote && !!futures.base) // filter out the futures with quote and base
          .reduce((acc, futures) => {
            acc[futures.instrumentAddr.toLowerCase()] = futures;
            return acc;
          }, {} as Record<string, Instrument>);

        if (instrumentMap) {
          const futuresRecords = reduceFutures(chainId, bigNumberObjectCheck(instrumentMap));

          // dispatch(fillEmptyAccount({ chainId, futuresRecords, userAddr }));
          return futuresRecords;
        }
      } catch (error) {
        console.error('🚀 ~parseInstrumentToMeta error:', error);
      }
    }
  },
);

export const updateFuturesFromChain = createAsyncThunk(
  'futures/updateFuturesFromChain',
  async ({
    futuresRecord,
  }: {
    chainId: CHAIN_ID;
    block: number;
    futuresRecord: IInstrumentRecord;
  }): Promise<IInstrumentRecord | undefined> => {
    if (futuresRecord) {
      // const {
      //   global: { chainTokenPriceInfo },
      // } = getState() as AppState;
      // let tokenPriceMap: TokenPriceInfoMap | undefined = undefined;
      // if (chainId) {
      //   if (_.get(chainTokenPriceInfo, [chainId])) {
      //     tokenPriceMap = _.get(chainTokenPriceInfo, [chainId]);
      //     console.log('🚀 ~ tokenPriceMap:', tokenPriceMap);
      //   }
      // }
      // const futuresRecord = reduceFutures(chainId, { [futures.info.addr.toLowerCase()]: futures }, tokenPriceMap);
      return futuresRecord;
    }
  },
);
